<template lang="html">
    <section class="hackDemo">
        <div class="Vlt-card Vlt-article">
            <div class="Vlt-col">
                <br>
                <div class="Vlt-grid">
                    <div class="Vlt-col">
                        <vlt-field label="Text to send">
                            <vlt-input id="textmessage" v-model="message" placeholer="Sample" :val="message" />
                        </vlt-field>
                    </div>
                    <div class="Vlt-col">
                        <vlt-field label="Number to send to">
                            <vue-phone-number-input color="#131415" :no-validator-state=true
                                :default-country-code="nexmo.region" v-model="prettyNumber" @update="onUpdate" />
                        </vlt-field>
                    </div>
                    <div v-if="false" class="Vlt-col">
                        <h3>Last Method: {{ method }}, Time Left: {{ countDown }}</h3>
                    </div>

                </div>
                <vlt-button label="Send a WhatsApp Message" secondary app @click="sendWA"
                    :disabled="(!message) || (!numberStuff.isValid)" />
                <vlt-button label="Send a WeChat Message" secondary app @click="sendWC"
                    :disabled="(!message) || (!numberStuff.isValid)" />
                <vlt-button label="Send a Text Message" secondary app @click="sendText"
                    :disabled="(!message) || (!numberStuff.isValid)" />
            </div>
            <div class="Vlt-grid">
                <div class="Vlt-col Vlt-col--A-1of2">
                    <b>Sent Messages</b><br><br>
                    <div class="Vlt-card Vlt-card--scrollable" style="height: 300px;">
                        <div class="Vlt-card__content">
                            <div class="Vlt-table Vlt-table--short">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Time</th>
                                            <th>Type</th>
                                            <th>To</th>
                                            <th>Message</th>
                                            <th>Status</th>
                                            <th>Received</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in delivery">
                                            <td>{{ item.time }}</td>
                                            <td>{{ item.type }}</td>
                                            <td>{{ item.to }}</td>
                                            <td>{{ item.message }}</td>
                                            <td>
                                                <vlt-icon v-if="!item.status" icon="envelope" color="red" />
                                                <vlt-icon v-else-if="item.status == 1" icon="call-outbound"
                                                    color="orange" />
                                                <vlt-icon v-else icon="thumbs-up" color="green" />
                                            </td>
                                            <td>{{ item.recd }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="Vlt-col Vlt-col--A-1of2">
                    <b>Received Messages</b><br><br>
                    <div class="Vlt-card  Vlt-card--scrollable" style="height: 300px;">
                        <div class="Vlt-card__content">
                            <div class="Vlt-table Vlt-table--short">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Time</th>
                                            <th>Type</th>
                                            <th>From</th>
                                            <th>Message</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in incoming">
                                            <td>{{ item.time }}</td>
                                            <td>{{ item.type }}</td>
                                            <td>{{ item.from }}</td>
                                            <td>{{ item.message }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="js">
import {
    $HTTPDEMO,
} from '../services/nidsService.js';
import Pusher from "pusher-js";
import {
    parsePhoneNumberFromString
} from 'libphonenumber-js';
import axios from 'axios';
import {
    VltIcon,
    VltButton,
    VltCard,
    VltTab,
    VltGrid,
    VltCol,
    VltField,
    VltInput,

} from "@vonagevolta/vue";
import ConversationClient from 'nexmo-client';
export const requestHandler = (request) => {
    if (true) {
        request.headers['Authorization'] = 'Bearer HARNESS'
    }
    return request
};
export default {
    name: 'hackDemo',
    data() {
        return {
            nexmo: {
                username: "DemoUser",
                firstname: "Demo",
                lastname: "User",
                role: "",
                phone: "6583206274",
                region: "SG",
                from: "14152370929",
                pusher_key: "cdc7710d27c3e5b38f46",
                tokbox_key: "46365762",
                userid: "1",
                port: 8010
            },
            countDown: 10,
            state: 0,
            method: 'None',
            HACK: {},
            nexmojs: {},
            kill: false,
            app: {},
            convo: 'CON-8701bd2f-83f8-4fc5-aeac-29c882d7d42b',
            con: {},
            message: 'Your package is on the way. Reply to confirm.',
            number: '',
            prettyNumber: '6583206274',
            numberStuff: {},
            incoming: [],
            delivery: [],
            fromNumber: '',
            wechatId: 'o988wwwBpPrBImh2TnTqZWGuPyDY',
            jwt: 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE1Njc2MzEwMDAsImp0aSI6IjZjN2E3NWEwLWNmNTctMTFlOS04Y2IwLWI5OWNkNGM4NWRmMyIsImFwcGxpY2F0aW9uX2lkIjoiMDQyOGMyZjYtZWRjYi00NzNlLTgyMDYtMjUzYjNhMjc2MGM3Iiwic3ViIjoiZGVtb191c2VyIiwiZXhwIjoxNTY3NjMxMDg2NDU3LCJhY2wiOnsicGF0aHMiOnsiL3YxL3VzZXJzLyoqIjp7fSwiL3YxL2NvbnZlcnNhdGlvbnMvKioiOnt9LCIvdjEvc2Vzc2lvbnMvKioiOnt9LCIvdjEvZGV2aWNlcy8qKiI6e30sIi92MS9pbWFnZS8qKiI6e30sIi92My9tZWRpYS8qKiI6e30sIi92MS9hcHBsaWNhdGlvbnMvKioiOnt9LCIvdjEvcHVzaC8qKiI6e30sIi92MS9rbm9ja2luZy8qKiI6e319fX0.kvft7QbNcI5l7uQc4UI4ZSoYi7jR7Xtom4td2gw2HWezTr4yoJHYFUQ7QlyVKpTvpCv5FTgL_rO5uUuaE2qV_RNyT9acW6IMAo1ZIvyymCdF91Hs9kNW33V7SiIBhDWlMDc4I7aYrAO7ueuv-XXbSDWLn_yATSpQezRb_whJ3B96KKlof4jiiDeVdrVuGLCuG46xjMT9VN9Z3IhO8LYwOiHmiVAae9EaYw_OJpIEw8jTaSHYXx9e1rzXAuI1_h-Q42tp9zsyhA17NxeoUgnTcAOMA9zxzEFa-340U6Bxap4sbSa5NhiO0_ugF7kJTBwxH0M7nPUmYtIF71K2koU5FA',
        }
    },
    props: {
        //        nexmo: {
        //            type: Object,
        //            required: false
        //        }
    },
    methods: {
        sendText() {
            console.log("To " + this.number + " we send: " + this.message);
            this.HACK.post('sms/outbound', {
                "wechatId": this.wechatId,
                "number": this.number,
                "message": this.message
            });
            this.pushMsg(this.delivery, this.incoming, 'Text', this.message, 'Nexmo');
            this.method = "SMS";
            this.state = 3;
            this.countDownTimer(10);
            this.$swal({
                title: 'Text Success',
                text: 'The Text Message has been sent to ' + this.numberStuff.formatInternational + '.',
                icon: 'success',
                position: 'top-end',
            });
        },
        sendWA() {
            console.log("To " + this.number + " we send: " + this.message);
            this.HACK.post('whatsapp/outbound', {
                "wechatId": this.wechatId,
                "number": this.number,
                "message": this.message
            });
            this.pushMsg(this.delivery, this.incoming, 'WhatsApp', this.message, 'Nexmo')
            this.method = "WhatsApp";
            this.state = 1;
            this.countDownTimer(10);
            this.$swal({
                title: 'WhatsApp Success',
                text: 'The WhatsApp Message has been sent to ' + this.numberStuff.formatInternational + '.',
                icon: 'success',
                position: 'top-end',
            });
        },
        sendWC() {
            console.log("To " + this.number + " we send: " + this.message);
            this.HACK.post('wechat/outbound', {
                "wechatId": this.wechatId,
                "number": this.number,
                "message": this.message
            });
            this.pushMsg(this.delivery, this.incoming, 'WeChat', this.message, 'Nexmo');
            this.method = "WeChat";
            this.state = 2;
            this.countDownTimer(10);
            this.$swal({
                title: 'WeChat Success',
                text: 'The WeChat Message has been sent to ' + this.numberStuff.formatInternational + '.',
                icon: 'success',
                position: 'top-end',
            });
        },
        pushMsg(stack1, stack2, type, message, from) {
            let date = new Date();
            let dt = date.toLocaleString();

            let newSend = {
                'time': dt,
                'type': type,
                'to': this.number,
                'from': from,
                'message': message,
                'status': 0,
                'recd': '',
            };
            stack1.unshift(newSend);
            let newReceive = {
                'time': '',
                'type': '',
                'to': '',
                'from': '',
                'message': '',
                'status': '',
                'recd': ''
            };
            //            stack2.unshift(newReceive);
        },
        register() {
            console.log("Registering the Demo Component with the associated backend");
        },
        onUpdate(payload) {
            this.numberStuff = payload;
            if (payload.isValid) {
                this.number = this.numberStuff.formattedNumber.replace(/\D/g, '');;
            } else {
                var test = parsePhoneNumberFromString(payload.formattedNumber);
                console.log("Re-checked number: ", test)
                if (test.isValid()) {
                    this.isValid = true;
                    this.number = test.number.replace(/\D/g, '');
                    console.log("new this.number = ", this.number)
                } else {
                    this.isValid = false;
                }
            }
        },
        getCurTime() {
            let date = new Date();
            return date.toLocaleString();
        },
        countDownTimer(secs) {
            return;
            this.countDown = secs;
            this.kill = true;
            if (this.countDown > 0) {
                setTimeout(() => {
                    console.log("countDown = " + this.countDown);
                    this.countDown -= 1;
                    if (this.countDown > 0 && !this.kill) { this.countDownTimer(this.countDown) } else { this.countDown = 0; this.kill = false };
                }, 1000)
            }
        }

    },
    components: {
        "vlt-icon": VltIcon,
        "vlt-button": VltButton,
        "vlt-field": VltField,
        "vlt-input": VltInput,
    },
    created() {
        this.HACK = axios.create({
            baseURL: 'https://pure-shore-95096.herokuapp.com/',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        this.HACK.interceptors.request.use(
            request => requestHandler(request)
        )
        this.register();
        console.log("Creating pusher subscription for key= " + this.nexmo['pusher_key'] + " phone " + this.nexmo['phone']);

        let pusher = new Pusher(this.nexmo['pusher_key'], { //Pusher Key
            cluster: 'us3',
            forceTLS: true
        });
        this.channel = pusher.subscribe("smsDemo");
        this.channel.bind("incoming", data => {
            console.log("Got some SMS data: " + JSON.stringify(data));
            this.incoming.unshift(data);
        });
        this.channel.bind("delivery", data => {
            console.log("Got some delivery data: " + JSON.stringify(data));
            this.delivery.unshift(data);
        });
        this.onUpdate({ isValid: true, formatInternational: this.nexmo['phone'], formattedNumber: this.nexmo['phone'] });
        this.fromNumber = parsePhoneNumberFromString("+" + this.nexmo['from']).formatInternational();
        this.prettyNumber = parsePhoneNumberFromString("+" + this.nexmo['phone']).formatNational();
        this.nexmojs = new ConversationClient()
            .createSession(this.jwt)
            .then(app => {
                console.log('Logged in to app', app);
                this.app = app;
                this.app.getConversation(this.convo).then(con => {
                    this.con = con;
                    this.con.on('custom:wechat', (member, event) => {
                        console.log('custom:wechat', member);
                        console.log('custom:wechat', event);
                        if (event.body.from == 'Nexmo') { //Confirmation!
                            this.delivery.forEach(function (item, index) {
                                if (item.type.toLowerCase() == event.body.type) {
                                    if (!item.status) {
                                        item.status = 1;
                                    } else if (item.status && item.message == event.body.message) {
                                        item.status = 2;
                                    }
                                    let date = new Date();
                                    item.recd = date.toLocaleString();
                                };
                            });
                        } else {
                            this.delivery.forEach(function (item, index) {
                                if (item.type.toLowerCase() == event.body.type) {
                                    item.status = 2;
                                };
                                let date = new Date();
                                item.recd = date.toLocaleString();
                            });
                            this.pushMsg(this.incoming, this.delivery, event.body.type, event.body.message, event.body.from);
                        };
                    });
                })
            })
            .catch(err => console.log(err));
    },
}
</script>

<style scoped lang="scss"></style>
